import { $, $$ } from '@3pc/dom';
import { ClickRedirect } from '@3pc/click-redirect';

const listTeasers = $$('.press-list__item');

if (listTeasers.length) {
  listTeasers.forEach(teaser => {
    // Get references to the source and target elements
    const targetElement = $('.press-list__link', teaser);
    const sourceImage = $('.press-list__picture', teaser);
    const sourceText = $('.press-list__text', teaser);
    const sourceElements = [sourceImage, sourceText].filter(Boolean); // Remove null/undefined elements

    // Define configuration options
    const config = {
      preventDefault: false, // Prevent the default click behavior
    };

    if (!targetElement) return;

    sourceElements.forEach(source => {
      // Create a ClickRedirect instance
      const instanceClickRedirect = new ClickRedirect(
        source,
        targetElement,
        config
      );

      // Activate the ClickRedirect (add event listeners)
      instanceClickRedirect.activate();
    });
  });
}
